class s {
  handleApiResponse(i, t) {
    var o, c;
    i.data && t.onSuccess(i.data), (o = i.errors) != null && o.length && t.onError(i.errors), (c = t.onComplete) == null || c.call(t);
  }
}
const f = new s();
export {
  f as default
};
